export default {
    TAKING_ORDERS: 'PRIMA PORUDŽBINE',
    TEMPORARY_OUT_OF_USE: 'TRENUTNO VAN UPOTREBE',
    CLOSED: 'ZATVOREN',
    OUT_OF_ORDER: 'VAN FUNKCIJE',
    AVAILABLE: 'DOSTUPAN',
    UNAVAILABLE: 'NEDOSTUPAN',
    ACTIVE: 'AKTIVAN',
    PENDING: 'NA ČEKANJU',
    EXPIRED: 'ISTEKLO',
    INACTIVE: 'NEAKTIVAN',
    YES: 'DA',
    NO: 'NE',
    COMPLETED: 'ZAVRŠENA',
    ACCEPTED: 'PRIHVAĆENA',
    IN_DELIVERY: 'U DOSTAVI',
    REJECTED: 'ODBIJENA',
    CANCELLED: 'OTKAZANA',
    SUCCESS: 'USPEŠNO',
    NOT_INITIATED: 'NIJE ZAPOČETO',
    FAILED: 'NEUSPEŠNO',
};
